import React, { useState } from "react";

const FacebookIcon = () => (
  <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="white">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M23.5 6.2a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.51A3.02 3.02 0 0 0 .5 6.2 31.4 31.4 0 0 0 0 12a31.4 31.4 0 0 0 .5 5.8 3.02 3.02 0 0 0 2.12 2.14c1.88.51 9.38.51 9.38.51s7.5 0 9.38-.51a3.02 3.02 0 0 0 2.12-2.14A31.4 31.4 0 0 0 24 12a31.4 31.4 0 0 0-.5-5.8Z" fill="#FF0000" />
    <path d="m9.6 15.9 6.3-3.9-6.3-3.9v7.8Z" fill="white" />
  </svg>
);

const RedditIcon = () => (
  <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" fill="#FF4500" />
    <circle cx="8.4" cy="12.2" r="1.2" fill="white" />
    <circle cx="15.6" cy="12.2" r="1.2" fill="white" />
    <path d="M8.2 15.1c1.05 1 2.35 1.5 3.8 1.5s2.75-.5 3.8-1.5" stroke="white" strokeWidth="1.35" strokeLinecap="round" />
    <path d="M14.05 7.6 15 5.2l2.1.45" stroke="white" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="17.45" cy="5.65" r="1.05" fill="white" />
  </svg>
);

const InstagramIcon = () => (
  <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none">
    {/* gradient background square */}
    <defs>
      <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f09433" />
        <stop offset="25%" stopColor="#e6683c" />
        <stop offset="50%" stopColor="#dc2743" />
        <stop offset="75%" stopColor="#cc2366" />
        <stop offset="100%" stopColor="#bc1888" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="url(#ig-grad)" />
    <rect x="5.5" y="5.5" width="13" height="13" rx="3" ry="3" fill="none" stroke="white" strokeWidth="1.5" />
    <circle cx="12" cy="12" r="3.2" fill="none" stroke="white" strokeWidth="1.5" />
    <circle cx="16.8" cy="7.2" r="1" fill="white" />
  </svg>
);

interface Platform {
  id: string;
  label: string;
  sub: string;
  accent: string;
  glow: string;
  href?: string;
  icon: React.ReactNode;
}

const platforms: Platform[] = [
  {
    id: "facebook",
    label: "Facebook",
    sub: "Follow TubeDealer",
    accent: "#1877F2",
    glow: "rgba(24,119,242,0.18)",
    href: "https://www.facebook.com/profile.php?id=61593149524810",
    icon: <FacebookIcon />,
  },
  {
    id: "youtube",
    label: "YouTube",
    sub: "Watch our videos",
    accent: "#FF0000",
    glow: "rgba(255,0,0,0.16)",
    href: "https://www.youtube.com/@tubedealer.comofficial",
    icon: <YoutubeIcon />,
  },
  {
    id: "reddit",
    label: "Reddit",
    sub: "Join the community",
    accent: "#FF4500",
    glow: "rgba(255,69,0,0.16)",
    href: "https://www.reddit.com/r/tubedealer/",
    icon: <RedditIcon />,
  },
  {
    id: "instagram",
    label: "Instagram",
    sub: "Follow TubeDealer",
    accent: "#C13584",
    glow: "rgba(193,53,132,0.18)",
    href: "https://www.instagram.com/tubedealerofficial/",
    icon: <InstagramIcon />,
  },
];

export default function SocialMediaPanel() {
  const [hovered, setHovered] = useState<string | null>(null);
  const [comingSoon, setComingSoon] = useState<string | null>(null);

  return (
    <div style={{ marginTop: 20, borderTop: "1px solid #1a1a1a", paddingTop: 20 }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
        <h2 style={{
          margin: 0,
          fontSize: 15,
          fontWeight: 700,
          color: "#fff",
          textTransform: "uppercase",
          letterSpacing: "0.1em",
          whiteSpace: "nowrap",
        }}>
          🔗 Social Media
        </h2>
        <div style={{ height: 1, flex: 1, background: "#1e1e1e", marginLeft: 16 }} />
      </div>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: 12,
      }}>
        {platforms.map((platform) => {
          const isHovered = hovered === platform.id;
          const isLive = "href" in platform;
          const cardStyle: React.CSSProperties = {
            background: isHovered ? "#111" : "#0c0c0c",
            border: `1px solid ${isHovered ? platform.accent : "#1c1c1c"}`,
            borderRadius: 12,
            padding: "16px 16px 14px",
            cursor: "pointer",
            transition: "border-color 0.18s, box-shadow 0.18s, transform 0.15s, background 0.15s",
            transform: isHovered ? "translateY(-3px)" : "translateY(0)",
            boxShadow: isHovered
              ? `0 6px 28px ${platform.glow}, 0 2px 8px rgba(0,0,0,0.4)`
              : "0 1px 4px rgba(0,0,0,0.3)",
            display: "flex",
            flexDirection: "column",
            gap: 10,
            userSelect: "none",
            textDecoration: "none",
            color: "inherit",
            font: "inherit",
            textAlign: "left",
            width: "100%",
          };

          const content = (
            <>
              <div style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
              }}>
                <div style={{
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  background: isHovered ? platform.glow : "#141414",
                  border: `1px solid ${isHovered ? `${platform.accent}40` : "#222"}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background 0.18s, border-color 0.18s",
                }}>
                  {platform.icon}
                </div>
                <span style={{
                  fontSize: 10,
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  padding: "2px 7px",
                  borderRadius: 20,
                  background: isHovered ? platform.glow : "#161616",
                  color: isHovered ? platform.accent : "#444",
                  border: `1px solid ${isHovered ? `${platform.accent}40` : "#222"}`,
                  transition: "all 0.18s",
                }}>
                  {isLive ? "LIVE" : "SOON"}
                </span>
              </div>

              <div>
                <div style={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: isHovered ? platform.accent : "#ddd",
                  transition: "color 0.18s",
                  marginBottom: 3,
                }}>
                  {platform.label}
                </div>
                <div style={{ fontSize: 11, color: "#555", lineHeight: 1.45 }}>
                  {platform.sub}
                </div>
              </div>

              <div style={{
                fontSize: 11,
                color: isHovered ? platform.accent : "#333",
                fontWeight: 600,
                transition: "color 0.18s",
              }}>
                {isLive ? "Open ↗" : "Coming soon"}
              </div>
            </>
          );

          return isLive ? (
            <a
              key={platform.id}
              className="resource-card"
              href={platform.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Open TubeDealer on ${platform.label} (opens in a new tab)`}
              onMouseEnter={() => setHovered(platform.id)}
              onMouseLeave={() => setHovered(null)}
              style={cardStyle}
            >
              {content}
            </a>
          ) : (
            <button
              key={platform.id}
              type="button"
              className="resource-card"
              aria-label={`${platform.label} is coming soon`}
              onClick={() => setComingSoon(platform.label)}
              onMouseEnter={() => setHovered(platform.id)}
              onMouseLeave={() => setHovered(null)}
              style={cardStyle}
            >
              {content}
            </button>
          );
        })}
      </div>

      {comingSoon && (
        <div
          role="status"
          aria-live="polite"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            marginTop: 12,
            padding: "10px 12px",
            border: "1px solid #2a2a2a",
            borderRadius: 10,
            background: "#101010",
            color: "#aaa",
            fontSize: 12,
          }}
        >
          <span><strong style={{ color: "#e8c070" }}>{comingSoon}</strong> is coming soon. We&apos;re getting it ready.</span>
          <button
            type="button"
            onClick={() => setComingSoon(null)}
            aria-label="Dismiss coming soon message"
            style={{
              border: "none",
              background: "transparent",
              color: "#666",
              cursor: "pointer",
              fontSize: 16,
              lineHeight: 1,
              padding: 2,
            }}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}